<template>
  <div class="square" :style="{'--icon-square-color': currentColors.background}">
    <icon v-bind="iconProps" />
  </div>
</template>

<script>
import Icon from '../Icon';
import { VARIANTS, COLOR_VARIANTS, COLORS } from './IconSquare.consts';

export default {
  name: 'IconSquare',
  components: { Icon },
  props: {
    iconName: {
      type: String,
      required: false,
    },
    colorVariant: {
      type: String,
      required: false,
      default: COLOR_VARIANTS.BLUE,
      validator: val => VARIANTS.includes(val),
    },
    /**
     * Size of the icon, a string with a unit.
     */
    iconSize: {
      type: String,
      default: '20px',
    },
    /**
     * For a font-icon, this determines the font weight. Default is normal.
     */
    weight: {
      type: String,
      default: 'normal',
      validator: val => ['normal', 'bold', '400', '700'].includes(val),
    },
    /**
     * For a font-icon, this determines the font weight. Default is normal.
     */
    opticalSize: {
      type: Number,
      default: 48,
      validator: val => val >= 20 && val <= 48,
    },
    alt: String,
  },
  computed: {
    currentColors() {
      return COLORS[this.colorVariant];
    },
    iconProps() {
      return {
        fill: true,
        iconName: this.iconName,
        size: this.iconSize,
        weight: this.weight,
        opticalSize: this.opticalSize,
        color: this.currentColors.icon,
        alt: this.alt,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/border-radius';
.square {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: var(--icon-square-color);
}

</style>
